module.exports = __webpack_public_path__ + "media/website-bg.ece4f70c.mp4";